<template>
  <div class="section-box">
    <el-tabs v-model="selectTab" type="card" class="customer-tabs-mg" @tab-click="handleReset"
      :before-leave="tabSelect">
      <el-tab-pane v-for="(item, index) in tabArray" :label="item.value" :name="item.key + ''"
        :key="index"></el-tab-pane>
    </el-tabs>

    <div class="customer-list">
      <el-row class="customer-row-bg">
        <el-col :span="17" style="text-align: left; display: flex; align-items: center">
          <el-form :inline="true" label-width="100px" label-position="right">
            <!-- <el-form-item label="子公司Id:">
              <el-input v-model="form.ZydCompanyId" placeholder="子公司企业Id"></el-input>
            </el-form-item> -->
            <el-form-item label="子公司名称:">
              <el-input v-model="form.ZydCompanyName" placeholder="子公司企业名称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="客户企业Id:">
              <el-input v-model="form.CompanyId" placeholder="客户企业Id"></el-input>
            </el-form-item> -->

            <el-form-item label="客户名称:">
              <el-input v-model="form.CompanyName" placeholder="客户企业名称"></el-input>
            </el-form-item>
            <el-form-item label="推送状态:">
              <el-radio-group v-model="form.IsPush" size="medium">
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="1">已推</el-radio-button>
                <el-radio-button label="2">未推</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="标签:">
              <el-radio-group v-model="form.JobTag" size="medium">
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="1">有标签</el-radio-button>
                <el-radio-button label="2">无标签</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="完成时间:">
              <!-- <el-input size="medium" style="width:150px;" v-model="form.spaperNo" placeholder="请输入考试编号" type="text" /> -->
              <el-date-picker size="" v-model="searchTime" type="daterange" format="yyyy-MM-dd" :clearable="false"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始"
                end-placeholder="结束" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-form inline label-width="90px" label-position="left" style="text-align: right">
            <el-form-item>
              <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 列表 -->
    <el-table :stripe="true" :data="tableData" border style="width: 100%; margin-top: 20px" v-loading="listLoading"
      :header-cell-style="{ background: '#F5F7FA' }">
      <!-- eslint-disable  -->
      <el-table-column label="工单ID" prop="0" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.JobId || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单编号" prop="0" show-overflow-tooltip width="130">
        <template slot-scope="scope">
          <span>{{ scope.row.JobNo || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户企业Id" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ (scope.row.CompanyId) || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户企业名称" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span>{{ (scope.row.SendJobCompany) || "--" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="映射母公司Id" show-overflow-tooltip width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.MapCompanyId || "--" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="映射母公司名称" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span :title="scope.row.MapCompanyId">{{ scope.row.MapCompanyName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单类别" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.Platform || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单标题" show-overflow-tooltip width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.JobTitle || "--" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="工单城市" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.JobProvince || "--" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="工单城市" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ (scope.row.JobProvince + ' - ' + scope.row.JobCity) || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="所属销售" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.SalesUserName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="子公司Id" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.SaleCompanyId || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="子公司" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.SaleCompanyName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="子公司累计金额" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.SaleCompanySumAmount || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="结算费用" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.SettlementAmount || "--" }}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column label="客户累计" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.TotalAmount || "--" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="完成时间" show-overflow-tooltip width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.CompleteTime || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标签" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.JobTagName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否推送" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ (scope.row.IsPush ? "已推送" : "未推送") || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推送时间" show-overflow-tooltip width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.PushTime || "--" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.PageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>


  </div>
</template>
<script>
import {
  getZydKaJobList
} from "@/service/salesStatistics";

export default {
  data() {
    return {
      searchTime: '',
      listLoading: false,
      form: {
        PageNum: 1,
        PageSize: 10,
        IsDesc: true,
        IsPush: 0,// 0全部，1已推送，0未推送
        JobTag: 0,//0 全部，1:有标签,2无标签
        CompanyId: "", //客户企业id
        CompanyName: "", //客户企业名称
        ZydCompanyId: "", //众业达子公司企业id
        ZydCompanyName: "", //众业达子公司企业id
        StartCompleteTime: "",
        EndCompleteTime: "",
      },
      oraginForm: { //搜索源数据
        PageNum: 1,
        PageSize: 10,
        IsDesc: true,
        IsPush: 0,// 0全部，1已推送，0未推送
        JobTag: 0,//0 全部，1:有标签,2无标签
        CompanyId: "", //客户企业id
        ZydCompanyId: "", //众业达子公司企业id
        StartCompleteTime: "",
        EndCompleteTime: "",
      },
      total: 0, //总条数
      tableData: [],

      pickerOptions: {
        shortcuts: [{
          text: '当月',
          onClick(picker) {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var str = year + '-' + month + "-1";
            var nmonth_first = new Date(str);

            picker.$emit('pick', [nmonth_first, today]);
          }
        }, {
          text: '当天',
          onClick(picker) {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            // var year=now.getFullYear();
            // var month=now.getMonth()+1;
            // var str=year+'-'+month+"-1";
            // var nmonth_first=new Date(str);

            picker.$emit('pick', [today, today]);
          }
        }]
      },
      selectTab: "1",
      tabArray: [{
        key: 1,
        value: "众业达子公司客户全部工单",
      }, {
        key: 2,
        value: "SaaS/灵工工单",
      }],
    };
  },
  created() { 
    this.initSearchTime();
    this.tableData = [];
    this.handleSearch();
  },
  activated() {
    this.initSearchTime();
  },
  methods: {
    initSearchTime() {
      const now = new Date();
      var today = new Date(now.toLocaleDateString());

      var year_today = today.getFullYear();
      var month_today = today.getMonth() + 1;
      var day_today = today.getDate();
      var today_str = year_today + '-' + month_today + '-' + day_today;
      console.log('today_str:' + today_str);

      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var start = year + '-' + month + "-1";
      console.log('start:' + start);
      var nmonth_first = new Date(start);
      // console.log('end 时间:' + nmonth_first);
      // this.searchTime = [nmonth_first, today];

      this.searchTime = [nmonth_first, today];
    },
    // 查询
    handleSearch() {
      this.handleCurrentChange(1);
    },
    // 重置
    handleReset() {
      this.form = JSON.parse(JSON.stringify(this.oraginForm));
      this.handleSearch();
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = 1;
      this.form.PageSize = val;
      this.GetZydKaJobData();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = val;
      this.GetZydKaJobData();
    },
    //获取edi工单列表
    async GetZydKaJobData() {
      this.listLoading = true;
      if (this.searchTime && this.searchTime.length) {
        this.form.StartCompleteTime = this.searchTime[0];
        this.form.EndCompleteTime = this.searchTime[1];
      }
      else {
        this.form.StartCompleteTime = "";
        this.form.EndCompleteTime = "";
      }
      let data = {
        // CompanyId: this.form.CompanyId,
        // ZydCompanyId:this.form.ZydCompanyId,
        IsPush: this.form.IsPush,
        JobTag: this.form.JobTag,

        PageNum: this.form.PageNum,
        PageSize: this.form.PageSize,
      };
      if (this.form.CompanyId != "") data.CompanyId = this.form.CompanyId;
      if (this.form.ZydCompanyId != "") data.ZydCompanyId = this.form.ZydCompanyId;
      if (this.form.CompanyName != "") data.CompanyName = this.form.CompanyName;
      if (this.form.ZydCompanyName != "") data.ZydCompanyName = this.form.ZydCompanyName;
      // if (this.form.CompanyName != "") data.CompanyName = this.form.CompanyName;
      if (this.form.StartCompleteTime != "") data.StartCompleteTime = this.form.StartCompleteTime;
      if (this.form.EndCompleteTime != "") data.EndCompleteTime = this.form.EndCompleteTime;

      console.log('searchTime:' + this.searchTime);
      console.log("data:" + JSON.stringify(data));

      let res = await getZydKaJobList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }
      this.tableData = res.Data.JobList;
      this.total = res.Data.TotalCount;
    },

    //切换tab之前
    tabSelect(activeName, oldActiveName) {
      console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);
      if (activeName == "1") {
        return true;
      }
      else {
        this.$router.push('ediJobList');
        console.log(1111);
        return false;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.customer-list {
  position: relative;

  .next-button {
    position: absolute;
    right: 0;
    top: -56px;
  }
}

.customer-row-bg {
  padding: 20px 14px;
  background-color: #f9fafc;
  display: flex;
  align-items: center;

  .el-form-item {
    margin-bottom: 15 !important;
  }

  .el-input {
    width: 235px;
  }

  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
</style>